<div fxLayout="column" fxFlexFill fxLayoutAlign="center center" class="forgot-password-page backgroundlogin bg-pattern">
  <div fxLayout="column" class="forgotcard">
    <form class="input-custom-all floating-input">
      <div class=" mat-elevation-z4">
        <div class="container-image">
          <div class="img-logo">
            <img src="assets/logo-white.png">
          </div>
        </div>
        <mat-card class="">
          <mat-card-title>
            <div class="container-image">
              <div class="icon-logo">
                <img src="assets/password.png">
              </div>
            </div>
          </mat-card-title>
          <mat-card-content class="">
            <div class="title-content">
              <label>Set-up your new password</label>
            </div>

            <form fxLayout="column" fxLayoutAlign="start stretch">


              <div class="password">
                <mat-form-field appearance="outline" class="">
                  <mat-label>New password</mat-label>
                  <input matInput type="password" placeholder="New password">
                  <div class="eye">
                    <!--show-->
                    <div class="button-click">
                      <mat-icon class="eye-custom">visibility</mat-icon>
                    </div>

                    <!--hide-->
                    <!-- <div class="button-click">
                        <mat-icon class="eye-custom" (click)="hideEye()">visibility_off</mat-icon>
                      </div> -->
                  </div>
                </mat-form-field>
                <mat-error>
                  harus diisi
                </mat-error>
              </div>
              <div class="password">
                <mat-form-field appearance="outline" class="">
                  <mat-label>Confirm password</mat-label>
                  <input matInput type="password" placeholder="Confirm password">
                  <div class="eye">
                    <!--show-->
                    <div class="button-click">
                      <mat-icon class="eye-custom">visibility</mat-icon>
                    </div>

                    <!--hide-->
                    <!-- <div class="button-click">
                      <mat-icon class="eye-custom" (click)="hideEye()">visibility_off</mat-icon>
                    </div> -->
                  </div>
                </mat-form-field>
                <mat-error>
                  harus diisi
                </mat-error>
              </div>


            </form>
            <div fxLayout="coloum" fxLayoutAlign="center" fxLayoutGap="20px" class="example-button-row">
              <div fxFlex="50">
                <button mat-flat-button class="btn-primary btn-full">Save</button>
              </div>
              <div fxFlex="50">
                <button mat-flat-button class="btn-tertier btn-full">Cancel</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </div>
</div>